import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateNominationIsCaseStudy: (
  fetchContext: FetchContext,
  nominationId: number,
  isCaseStudy: boolean,
  countryId?: number,
  accessToken?: string,
) => Promise<void> = (fetchContext, nominationId, isCaseStudy, countryId, accessToken) => {
  const searchParams = new URLSearchParams();
  if (countryId !== undefined) {
    searchParams.append('countryId', countryId.toString());
  }

  const queryString = searchParams.size > 0 ? `?${searchParams}` : '';

  return fetch(`${fetchContext.baseUrl}/api/staff/nominations/${nominationId}/is-case-study${queryString}`, {
    method: 'PUT',
    body: JSON.stringify({ value: isCaseStudy }),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
    .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update nomination is case study'));
};
